import { parseAttachments } from '@/lib/airtable/transform';

export interface CompanyFields {
  logoSrc: string;
  name: string;
  description: string;
  website?: string;
  websiteUrl?: string;
  location?: string;
  slug?: string;
}

export function extractCompanyFields(company: any, currentTableSchema: any): CompanyFields {
  if (!company || !currentTableSchema) return { logoSrc: '', name: '', description: '' };
  const logoField = currentTableSchema.fields.find((f: any) => f.type === 'multipleAttachments' && (f.name.toLowerCase().includes('logo') || f.name.toLowerCase().includes('image')))?.name;
  const nameField =
    currentTableSchema.fields.find((f: any) => f.name.toLowerCase() === 'company')?.name ||
    currentTableSchema.fields.find((f: any) => f.name.toLowerCase().includes('name'))?.name ||
    'Name';
  const descriptionField = currentTableSchema.fields.find((f: any) => f.name.toLowerCase().includes('description') || f.name.toLowerCase().includes('summary'))?.name;
  const fieldsToShow = Object.keys(company);
  const websiteField = fieldsToShow.find(f => f.toLowerCase().includes('website'));
  const locationField = fieldsToShow.find(f => f.toLowerCase() === 'location');
  const slugField = fieldsToShow.find(f => f.toLowerCase() === 'slug');

  const attachments = (logoField && company[logoField] && Array.isArray(company[logoField]))
    ? parseAttachments(company[logoField]) ?? []
    : [];
  const logo = attachments.length > 0 ? attachments[0] : null;
  const logoSrc = logo && typeof logo === 'object' ? (logo.thumbnailLarge ?? logo.url ?? '') : '';
  const name = company[nameField] || '';
  const description = descriptionField ? company[descriptionField] : '';
  const website = websiteField ? company[websiteField] : undefined;
  let websiteUrl = website;
  if (website && typeof website === 'string' && !/^https?:\/\//i.test(website)) websiteUrl = 'https://' + website;
  let location = locationField ? company[locationField] : undefined;
  if (!location) {
    const city = company['City'] || '';
    const state = company['State'] || '';
    const country = company['Country'] || '';
    location = [city, state, country].filter(Boolean).join(', ');
  }
  const slug = slugField ? company[slugField] : undefined;
  return { logoSrc, name, description, website, websiteUrl, location, slug };
} 